import React from 'react';
import { Box, Typography } from '@mui/material';
import { format, isToday } from 'date-fns';
import { useNavigate } from 'react-router';

import { useDataState } from '../../../providers/DataProvider.hooks';
import ContentContainer from '../../common/ContentContainer';
import { getSuffix } from '../../../utils/helpers';

import { ReactComponent as BackIcon } from '../../../assets/common/go_back.svg';
import { ReactComponent as LeaderboardIcon } from '../../../assets/clan/leaderboard.svg';
import clock from '../../../assets/common/clock.svg';

export const ClanHeader = () => {
    const navigate = useNavigate();
    const { selectedClan, clans } = useDataState();

    return (
        <ContentContainer>
            <Box
                display={'flex'}
                justifyContent={'space-between'}
                sx={{ borderBottom: '1px solid #EBEEF0', marginBottom: '30px' }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        margin: '20px 0',
                        cursor: 'pointer',
                        '&:hover': {
                            opacity: 0.8,
                        },
                    }}
                    onClick={() => {
                        navigate('/');
                    }}
                >
                    <BackIcon />
                    <Typography
                        sx={{
                            color: '#B2B7BE',
                            fontFamily: 'AvenirNext600',
                            fontSize: '16px',
                        }}
                    >
                        Back to tournament
                    </Typography>
                </Box>
            </Box>
            <Box display="flex">
                <Box
                    sx={{
                        width: '245px',
                        height: '245px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{
                            width: '200px',
                            height: '200px',
                            borderRadius: '50%',
                            backgroundImage: `url(${selectedClan?.picture})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    ></Box>
                </Box>
                <Box
                    sx={{
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        marginLeft: '20px',
                    }}
                >
                    <Typography
                        sx={{
                            color: '#0F0E0E',
                            fontFamily: 'AvenirNext700',
                            fontSize: '48px',
                        }}
                    >
                        {selectedClan?.clan}
                    </Typography>
                    <Box display={'flex'} gap={'15px'}>
                        <Box
                            sx={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                backgroundImage: `url(${selectedClan?.leader_avatar})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}
                        ></Box>
                        <Box>
                            <Typography
                                sx={{
                                    color: '#9298A1',
                                    fontFamily: 'AvenirNext400',
                                    fontSize: '14px',
                                }}
                            >
                                Clan Leader:
                            </Typography>
                            <Typography
                                sx={{
                                    color: '#0F0E0E',
                                    fontFamily: 'AvenirNext500',
                                    fontSize: '16px',
                                }}
                            >
                                {selectedClan?.leader_username}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
                <Box display="flex" flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
                    <Box
                        sx={{
                            backgroundColor: 'rgba(253, 187, 83, 0.1)',
                            borderRadius: '15px',
                            padding: '20px',
                            textAlign: 'center',
                            width: '304px',
                        }}
                    >
                        <LeaderboardIcon />
                        <Typography
                            sx={{
                                color: '#0F0E0E',
                                fontFamily: 'AvenirNext400',
                                fontSize: '14px',
                                opacity: 0.4,
                                marginTop: '15px',
                            }}
                        >
                            Current Tournament position
                        </Typography>

                        <Typography
                            sx={{
                                color: '#0F0E0E',
                                fontFamily: 'AvenirNext700',
                                fontSize: '24px',
                            }}
                        >
                            {getSuffix(selectedClan?.scoreboardPosition)} place
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            margin: '10px',
                        }}
                    >
                        <img src={clock} alt="clock"></img>
                        <Typography
                            component="span"
                            sx={{
                                color: '#9298A1',
                                fontFamily: 'AvenirNext400',
                                fontSize: '16px',
                                margin: '0 5px',
                            }}
                        >
                            Last updated
                        </Typography>
                        {clans?.last_modified && (
                            <Typography
                                component="span"
                                sx={{
                                    color: '#0F0E0E',
                                    fontFamily: 'AvenirNext500',
                                    fontSize: '16px',
                                }}
                            >
                                {isToday(clans.last_modified) ? 'Today at' : 'Yesterday at'}{' '}
                                {format(clans.last_modified, 'HH:mm')}
                            </Typography>
                        )}
                    </Box>
                </Box>
            </Box>
        </ContentContainer>
    );
};
